<template>
    <div id="hqmh">
        <headTop :id="id" @topback="topback"></headTop>
        <div class="banner" id="index">
            <img src="../../../static/images/zhhqbjt.png" alt="" style="width: 100%;">
        </div>
        <detailBread :breadName="'监督管理平台'"></detailBread>
        <div  class="container">
            <div class="page-title">
                监督管理平台 
            </div>
            <div class="page-content">
                <img src="../../../static/images/zhhq-jdglpt-01.png" alt="">
                <img style="margin:40px 0;" src=".../../../static/images/zhhq-jdglpt-02.png" alt="">
                <img style="margin:40px 0;" src="../../../static/images/zhhq-jdglpt-03.png" alt="">
                <img src="../../../static/images/zhhq-jdglpt-04.png" alt="">
            </div>
        </div>
    </div>
</template>
<script>
import headTop from '@/components/headTop'
import detailTop from '@/components/detailTop'
import detailBread from '@/components/detailBread'
export default {
    metaInfo: {
        title: '监督管理平台', // set a title
        meta: [{             // set meta
            name: 'keyWords',
            content: '监督管理平台'
        },
        {
            name: 'description',
            content: '监督管理平台'
        }],
    },
    components:{
        detailTop,
        detailBread,
        headTop
    },
    data() {
        return {
            id:'1',
        }
    },
    methods: {
        topback(){
            this.$router.push({
                path:'/',
            })
        }
    },
    mounted() {
        $('html,body').animate({
            scrollTop: 0 + "px"
        }, {
            duration: 0,
            easing: "swing"
        });
        return false;
    },
    
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/old/jdglpt.vue